import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { App as AntApp } from 'antd';
import { AppLayout } from './components/layout/AppLayout';
import { LoginPage } from './pages/LoginPage';
import { ProductListPage } from './pages/ProductListPage';
import { ProductDetailPage } from './pages/ProductDetailPage';
import { ImportPage } from './pages/ImportPage';
import { PreseedPage } from './pages/PreseedPage';
import { SettingsPage } from './pages/SettingsPage';
import { LogsPage } from './pages/LogsPage';
import { CoveragePage } from './pages/CoveragePage';
import { SourceContributionPage } from './pages/SourceContributionPage';
import { ApiGuideUserPage } from './pages/ApiGuideUserPage';
import { ApiGuideAdminPage } from './pages/ApiGuideAdminPage';

function App() {
  return (
    <AntApp>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<AppLayout />}>
            <Route index element={<Navigate to="/products" replace />} />
            <Route path="products" element={<ProductListPage />} />
            <Route path="products/:productId" element={<ProductDetailPage />} />
            <Route path="products/pim/:pimProductId/sources/:sourceName" element={<SourceContributionPage />} />
            <Route path="browse" element={<Navigate to="/products" replace />} />
            <Route path="import" element={<ImportPage />} />
            <Route path="preseed" element={<PreseedPage />} />
            <Route path="logs" element={<LogsPage />} />
            <Route path="coverage" element={<CoveragePage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="api-guide" element={<ApiGuideUserPage />} />
            <Route path="api-guide/admin" element={<ApiGuideAdminPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/products" replace />} />
        </Routes>
      </BrowserRouter>
    </AntApp>
  );
}

export default App;
